import TooltipV2 from '@/components/Tooltip/TooltipV2';
import { getSourceIcon } from '@/types/feedbackConst';
import { DATE_FORMAT, getTimezoneDayjs } from '@/utils/time';

import type { FlattenMentionItem } from './types';

export const MentionItem = (props: {
  mention: FlattenMentionItem;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}) => {
  const { mention, onClick } = props;
  const { source_name, source_type, text, contact_name, account_name, date } =
    mention;

  const sourceIcon = getSourceIcon(Number(source_type), 14);

  return (
    <div
      className="flex flex-col gap-1.5 py-2 px-3.5 hover:bg-gray-200 cursor-pointer rounded-lg transition-all duration-200"
      onClick={onClick}
    >
      <p className="text-gray-950 text-sm">{text}</p>
      <div className="flex gap-1.5 items-center text-xs text-gray-600">
        <TooltipV2 tooltipNode={source_name}>{sourceIcon}</TooltipV2>
        <span>{getTimezoneDayjs(date).format(DATE_FORMAT.readable)}</span>
        <span>{contact_name}</span>
        <span>{account_name}</span>
      </div>
    </div>
  );
};
